import { useState } from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import Tooltip from '@veeva/corgix/tooltip';
import { Overlay } from '@veeva/corgix/overlay';
import Icon from '@veeva/corgix/icon';
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import { isMobile } from '../services/DeviceInformation';

const propTypes = {
    children: PropTypes.node,
    content: PropTypes.node,
    // emotion custom style applied to the desktop version of the tooltip
    desktopTooltipCSS: PropTypes.shape({}),
};

const ResponsiveTooltip = ({ children, content, desktopTooltipCSS }) => {
    const [showTooltip, setShowTooltip] = useState(false);

    const handleShowTooltip = () => {
        setShowTooltip(true);
    };

    const handleCloseTooltip = (e) => {
        e.stopPropagation();
        setShowTooltip(false);
    };

    return isMobile() ? (
        <span onClick={handleShowTooltip}>
            {children}
            {showTooltip && (
                <div
                    css={[
                        css`
                            position: fixed;
                            top: 0;
                            left: 0;
                            width: 100%;
                            height: 100%;
                            background-color: black;
                            opacity: 0.3;
                            z-index: 399; // Overlay z-index is 400
                        `,
                    ]}
                />
            )}
            <Overlay
                open={showTooltip}
                css={[
                    css`
                        flex-direction: column;
                        width: 75%;
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                        transition: all 0.2s ease-in-out;
                        padding: 3rem 2rem 2rem;
                        background-color: white;
                        border-radius: 4px;
                        box-shadow: 0px 24px 38px 3px rgba(0, 0, 0, 0.14),
                            0px 9px 46px 8px rgba(0, 0, 0, 0.12),
                            0px 11px 15px -7px rgba(0, 0, 0, 0.2);
                        -webkit-tap-highlight-color: transparent; // Fix for Chrome mobile devices blue highlight on tap
                        font-size: 1.333rem;
                    `,
                ]}
                onRootClose={handleCloseTooltip}
            >
                <span
                    css={css`
                        position: absolute;
                        display: flex;
                        right: 0;
                        top: 0;
                        justify-content: flex-end;
                        padding: 1rem;

                        > svg.svg-inline--fa {
                            width: 1.5rem;
                            height: 1.5rem;
                        }
                    `}
                    onClick={handleCloseTooltip}
                >
                    <Icon type={faTimes} />
                </span>
                {content}
            </Overlay>
        </span>
    ) : (
        <Tooltip content={content} css={desktopTooltipCSS}>
            {children}
        </Tooltip>
    );
};

ResponsiveTooltip.propTypes = propTypes;

export default ResponsiveTooltip;
